module.exports = __webpack_public_path__ + "static/media/FILTER.da704cc0.png";